import React from 'react'
import axios from 'axios'
import {
	Button,
	Input
} from 'reactstrap'

import IngredientsTypesActions from '~/actions/ingredientsTypes.js'

import apiUtils from '~/helper/api.js'


export default class RecipeIngredientsTypesModalAddEdit extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			btnSubmitDisabled: true,
			ingredientType: props.ingredientType
		}
	}

	componentDidMount() {
		this.setSubmitButtonStatus()
	}

	setSubmitButtonStatus = () => {
		this.setState({
			btnSubmitDisabled: (
				this.state.ingredientType === ''
			)
		})
	}

	handleChange = (event) => {
		this.setState(
			{ [event.target.name]: event.target.value },
			this.setSubmitButtonStatus
		)
	}

	submit = () => {
		this.setState({ btnSubmitDisabled: true })

		axios.put(
			`${apiUtils.getApiURL()}/ingredientTypes`,
			{
				ingredientTypeID: this.props.ingredientTypeID,
				ingredientType: this.state.ingredientType,
				isActive: 1
			}
		)
			.then(
				() => {
					this.props.cancelFunction()

					// refresh the list
					IngredientsTypesActions.reload()
				}
			)
	}

	render() {
		const objSubmitButton = {}

		if (this.state.btnSubmitDisabled === true) {
			objSubmitButton.title = 'Enter ingredient type to enable this button'
		}


		return (
			<tr>
				<td>
					<Input
						name="ingredientType"
						value={this.state.ingredientType}
						onChange={this.handleChange}
						maxLength={32}
					/>
				</td>
				<td>
					<Button
						onClick={this.submit}
						color="primary"
						disabled={this.state.btnSubmitDisabled}
						block
						{...objSubmitButton}
					>
						Save
					</Button>
				</td>
				<td>
					<Button
						onClick={this.props.cancelFunction}
						color="secondary"
						block
					>
						Cancel
					</Button>
				</td>
			</tr>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/ingredientsTypes/edit.jsx